import { useEffect, useState } from "react";

// Path-based router using the History API.
// All admin routes live under /app/ so only that one prefix
// needs to be reserved — no individual slug conflicts possible.
export function useHashRoute(): string {
  const [route, setRoute] = useState(currentPath());
  useEffect(() => {
    const update = () => setRoute(currentPath());
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);
  return route;
}

function currentPath(): string {
  return window.location.pathname + window.location.search;
}

export function navigate(path: string) {
  // Strip legacy # prefix from any callers not yet updated.
  if (path.startsWith("#")) path = path.slice(1);
  // Ensure /app prefix for admin routes.
  if (!path.startsWith("/")) path = "/" + path;
  if (!path.startsWith("/app") && !path.startsWith("/share") && !path.startsWith("/api")) {
    path = "/app" + path;
  }
  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
